
/*
 * ETERNAL BLOOM — SHOPPING BAG NAVIGATION
 *
 * Empty bag: open /cart
 * Populated bag: open Prestige cart drawer
 * Keeps navigation updated without refreshing.
 */

(() => {
  const cartUrl = window.Shopify?.routes?.root
    ? `${window.Shopify.routes.root}cart`
    : "/cart";

  const getCartLinks = () =>
    document.querySelectorAll(
      '.header__cart-link a[href*="/cart"]'
    );

  async function updateCartNavigation() {
    try {
      const response = await fetch(
        `${cartUrl}.js`,
        { credentials: "same-origin" }
      );

      if (!response.ok) return;

      const cart = await response.json();

      getCartLinks().forEach((link) => {
        if (cart.item_count === 0) {
          link.removeAttribute("aria-controls");
        } else {
          link.setAttribute("aria-controls", "cart-drawer");
        }
      });
    } catch (error) {
      console.warn(
        "Eternal Bloom: Unable to update cart navigation.",
        error
      );
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    updateCartNavigation
  );

  document.addEventListener(
    "cart:change",
    updateCartNavigation
  );

  document.addEventListener(
    "cart:refresh",
    updateCartNavigation
  );
})();
